import * as React from 'react';
import tw from 'twin.macro';
import { HashLoader } from 'react-spinners';

// styles
const Wrapper = tw.div`
  h-screen w-screen flex flex-col justify-center items-center
`;

export const PageLoader = (): JSX.Element => {
  return (
    <Wrapper>
      <HashLoader size={100} color="#000" />
      <h2 className="text-xl font-semibold mt-5">Loading...</h2>
    </Wrapper>
  );
};
